module.exports = __webpack_public_path__ + "static/media/icon2.4ecd0710.svg";